import { render, staticRenderFns } from "./CityDetailAbout.vue?vue&type=template&id=4933f64e&scoped=true&"
import script from "./CityDetailAbout.vue?vue&type=script&lang=js&"
export * from "./CityDetailAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4933f64e",
  null
  
)

export default component.exports